'use client';

// eslint-disable-next-line no-restricted-imports
import { sendGTMEvent } from '@next/third-parties/google';

import { GTMPageCategory } from './types';

export type GTMPromotionSource = 'slider' | 'static';

export const getGTMPromotionSource = (
  slidesCount: number
): GTMPromotionSource => (slidesCount > 1 ? 'slider' : 'static');

export type GTMPromotionItem = {
  id: string;
  name: string | null;
  creative: string | null;
  creative_slot: string;
  position: number;
};

export type GTMEventNamePromotion = 'view_promotion' | 'select_promotion';

export const toGTMPromotionPageCategorySlug = (pageCategory: GTMPageCategory) =>
  pageCategory.replace(/\s+/g, '_').replace(/::/g, '_');

export const getPromotionCreativeSlot = (
  pageCategory: GTMPageCategory,
  source: GTMPromotionSource
) => `${toGTMPromotionPageCategorySlug(pageCategory)}_${source}`;

export const toGTMAbsoluteUrl = (url?: string): string | null => {
  if (!url) return null;
  if (typeof window === 'undefined') return url;

  try {
    return new URL(url, window.location.origin).href;
  } catch {
    return url;
  }
};

export const toGTMPromotionId = (url?: string): string =>
  toGTMAbsoluteUrl(url) || 'internal';

export const buildGTMPromotionEcommerce = ({
  creativeName,
  promotionId,
  promotionName,
  pageCategory,
  source,
  index = 1
}: {
  creativeName?: string;
  promotionId?: string;
  promotionName?: string;
  pageCategory: GTMPageCategory;
  source: GTMPromotionSource;
  index?: number;
}): GTMPromotionItem => ({
  id: toGTMPromotionId(promotionId),
  name: promotionName?.trim() || null,
  creative: toGTMAbsoluteUrl(creativeName),
  creative_slot: getPromotionCreativeSlot(pageCategory, source),
  position: index
});

export const sendGTMEventPromotion = (
  event: GTMEventNamePromotion,
  promotion: GTMPromotionItem
) => {
  const promoKey = event === 'view_promotion' ? 'promoView' : 'promoClick';

  sendGTMEvent({ ecommerce: null });
  sendGTMEvent({
    event,
    ecommerce: {
      [promoKey]: {
        promotions: [promotion]
      }
    }
  });
};
